import { render, staticRenderFns } from "./UserFigure.vue?vue&type=template&id=579e227a"
import script from "./UserFigure.vue?vue&type=script&lang=js"
export * from "./UserFigure.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports